/**
 * Компонент окна онлайн поддержки
 */

import React, { useState, useEffect, useRef } from 'react';
import { useChatContext } from './ChatContext';
import './ChatWindow.css';

const ChatWindow = () => {
    const { isOpen, closeChat, messages, addMessage, isOperatorOnline } = useChatContext();
    const [inputValue, setInputValue] = useState('');
    const messagesEndRef = useRef(null);

    // Автоскролл к последнему сообщению
    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages]);

    const handleSendMessage = (e) => {
        e.preventDefault();
        if (inputValue.trim()) {
            addMessage({
                type: 'user',
                text: inputValue
            });
            setInputValue('');
        }
    };

    // Форматирование времени из created_at
    const formatTime = (timestamp) => {
        return new Date(timestamp).toLocaleTimeString('ru-RU', { 
            hour: '2-digit', 
            minute: '2-digit' 
        });
    };

    if (!isOpen) return null;

    return (
        <div className="chat-window">
            {/* Хедер в стиле терминала */}
            <div className="chat-window__header">
                <div className="chat-window__dots">
                    <span className="chat-window__dot"></span>
                    <span className="chat-window__dot"></span>
                    <span className="chat-window__dot"></span>
                </div>
                <div className="chat-window__title">
                    <span className={`chat-window__status ${isOperatorOnline ? 'chat-window__status_online' : 'chat-window__status_offline'}`}></span>
                    {isOperatorOnline ? 'Online Support' : 'Offline Support'}
                </div>
                <button 
                    className="chat-window__close" 
                    onClick={closeChat}
                    aria-label="Закрыть чат"
                >
                    ✕
                </button>
            </div>

            {/* Тело чата */}
            <div className="chat-window__body">
                <div className="chat-window__messages">
                    {messages.map((msg) => (
                        <div 
                            key={msg.id} 
                            className={`chat-message chat-message_${msg.type}`}
                        >
                            <div className="chat-message__text">{msg.message || msg.text}</div>
                            <div className="chat-message__time">
                                {msg.created_at ? formatTime(msg.created_at) : msg.time}
                            </div>
                        </div>
                    ))}
                    <div ref={messagesEndRef} />
                </div>
            </div>

            {/* Форма ввода */}
            <form className="chat-window__form" onSubmit={handleSendMessage}>
                <input
                    type="text"
                    className="chat-window__input"
                    placeholder="Напишите сообщение..."
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                />
                <button 
                    type="submit" 
                    className="chat-window__send"
                    aria-label="Отправить сообщение"
                    disabled={!inputValue.trim()}
                >
                    <svg 
                        width="20" 
                        height="20" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path 
                            d="M22 2L11 13M22 2L15 22L11 13M22 2L2 8L11 13" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </form>
        </div>
    );
};

export default ChatWindow;
